import axios from "axios";

// 기존 Axios의 baseURL과 로그인 JWT를 사용한다.
export async function parseKakaoOrder({ text, companyId, signal }) {
  const { data } = await axios.post("/orders/parse-kakao", { text, companyId }, {
    signal,
    timeout: 70000,
  });
  return data;
}
